import {
  useRecordContext,
  RecordContextProvider,
  NumberField,
  TabbedShowLayout,
  useTranslate,
} from "react-admin";
import Box from "@mui/material/Box";

const SaleNetCardExpandList = () => {
  const record = useRecordContext();
  const t = useTranslate();

  if (!record || !Array.isArray(record.sale_items)) {
    return null; // Bisa diganti dengan skeleton/loading indicator jika perlu
  }

  const hasData = record.sale_items.some(
    (item) => Array.isArray(item.sale_item_hpps) && item.sale_item_hpps.length > 0
  );

  return (
    <TabbedShowLayout
      syncWithLocation={false}
      sx={{
        m: 4,
        backgroundClip: "padding-box",
        boxShadow: (theme) => {
          return theme.components.MuiPaper
            ? theme.components.MuiPaper.styleOverrides.elevation1.boxShadow
            : undefined;
        },
        borderRadius: "4px",
        bgcolor: "background.paper",
        "& .RaTabbedShowLayout-content": {
          p: 0,
        },
        "& .RaLabeled-label": {
          display: "none",
        },
      }}
    >
      <TabbedShowLayout.Tab label={t("mine.label.product")}>
        <Box
          component="table"
          sx={{
            width: "100%",
            borderCollapse: "collapse",
            "& th, td": {
              padding: "6px 8px",
              border: "1px solid #dddddd",
            },
          }}
        >
          <thead>
            <tr>
              <th>{t("mine.label.code")}</th>
              <th>{t("mine.label.name")}</th>
              <th style={{ textAlign: "right" }}>
                {t("mine.label.sent_quantity")}
              </th>
              <th style={{ textAlign: "right" }}>{t("mine.label.cogs")}</th>
              <th style={{ textAlign: "right" }}>{t("mine.label.price")}</th>
              <th style={{ textAlign: "right" }}>Discount/Box</th>
              <th style={{ textAlign: "right" }}>Special discount/Box</th>
              <th style={{ textAlign: "right" }}>Transport Cost/Box</th>
              <th style={{ textAlign: "right" }}>Subtotal</th>
            </tr>
          </thead>
          <tbody>
            {hasData ? (
              record.sale_items.flatMap((item, idx) =>
                Array.isArray(item.sale_item_hpps)
                  ? item.sale_item_hpps.map((hpp, index) => (
                      <tr key={`${item.id}-${idx}-${index}`}>
                        <td>{item.product.code}</td>
                        <td>{item.product.name}</td>
                        <td style={{ textAlign: "right" }}>
                          <RecordContextProvider value={hpp}>
                            <NumberField
                              source="quantity"
                              sx={{ fontSize: "inherit" }}
                            />
                          </RecordContextProvider>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <RecordContextProvider value={hpp}>
                            <NumberField
                              source="inventory.cogs"
                              sx={{ fontSize: "inherit" }}
                            />
                          </RecordContextProvider>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <RecordContextProvider value={item}>
                            <NumberField
                              source="price"
                              sx={{ fontSize: "inherit" }}
                            />
                          </RecordContextProvider>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <RecordContextProvider value={item}>
                            <NumberField
                              source="disc"
                              sx={{ fontSize: "inherit" }}
                            />
                          </RecordContextProvider>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <RecordContextProvider value={item}>
                            <NumberField
                              source="spc_disc"
                              sx={{ fontSize: "inherit" }}
                            />
                          </RecordContextProvider>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <RecordContextProvider value={item}>
                            <NumberField
                              source="transport_cost"
                              emptyText="0"
                              sx={{ fontSize: "inherit" }}
                            />
                          </RecordContextProvider>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <RecordContextProvider value={hpp}>
                            <NumberField
                              source="subtotal_sale_price"
                              sx={{ fontSize: "inherit" }}
                            />
                          </RecordContextProvider>
                        </td>
                      </tr>
                    ))
                  : []
              )
            ) : (
              <tr>
                <td colSpan={9} style={{ textAlign: "center", padding: "12px" }}>
                  {t("No data available for the selected period")}
                </td>
              </tr>
            )}
          </tbody>
        </Box>
      </TabbedShowLayout.Tab>
    </TabbedShowLayout>
  );
};

export default SaleNetCardExpandList;
